import { ApiResponse } from "./generalResponse";

export interface iSearchResultsResponse extends ApiResponse {
  // You could add errName, errMsg, etc., if your server returns them
  data: ContextSearchResults;
}

export interface iSearchResultsState {
  searchResults: iSearchResultsResponse | null
  searchResultsCountries?: iSearchResultsResponse | null
}

export interface ContextSearchResults {
  searchedContext: ContextName,
  results: ContextSearchResult[]
}

interface ReferenceValue {
  amount: number;
  unit: string;
  systemBoundaries: string;
}

export interface FullContext {
  contextName: string;
  fullName: string;
  shortName: string;
  className: string;
  centralProductClassification: string;
  hs2017Classification: string;
  group: string;
}

export interface ContextSearchResult {
  sid: string;
  uuid?: string;
  name: string;
  contextName: string;
  database: string;
  type: string;
  description: string;
  imgUrl?: string,
  referenceValue?: ReferenceValue;
  fullContext?: FullContext;
}

export interface Variant {
    variant: string,
    variantTag: string,
    id: string,
}

export enum ContextName {
    NONE = "_",
    GLOBAL = ".",
    ENERGY = ".energy",
    CARRIERS  = ".energy.carriers",
    COUNTRIES  = ".energy.countries",
    LOGISTICS = ".logistics",
    MATERIALS = ".materials",
    PRODUCTION = ".production",
    ELECTRONICS = ".electronics",
    CONSUMER_PRODUCTS = ".consumerProducts",
    PACKAGING = ".logistics.packaging",
    TRANSPORTATION = ".logistics.transportation",
    COMPOSITES = ".materials.composites",
    CONSTRUCTION = ".materials.construction",
    ELEMENTS = ".materials.elements",
    METALS = ".materials.metals",
    POLYMERS = ".materials.polymers",
    CHEMICALS = ".materials.chemicals",
    SINTERS = ".materials.sinters",
    EMPLOYEES = ".production.employees",
    EQUIPMENT = ".production.equipment",
    MANUFACTURING = ".production.manufacturing"
  }
  